export default "__VITE_PUBLIC_ASSET__950fc9eb__"